import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateViewAdmin = (params) => {
    return axios.post(`${backendHost}/api/admin/allows`, params);
};

export {
    postUpdateViewAdmin
}